import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  height: 100%;

  .empty-table-background {
    display: flex;
    height: 100%;
    width: 100%;
    background-color: #f5f5f5;
  }

  .empty-table-content {
    display: flex;
    text-align: center;
    justify-content: center;
    margin: auto;
  }
`;

const EmptyTable = () => (
  <>
    <StyledDiv>
      <div className="empty-table-background">
        <div className="empty-table-content">No rows found</div>
      </div>
    </StyledDiv>
    {/* нужен для корректного отображения пустого футера с пагинацией */}
    <table />
  </>
);

export default EmptyTable;
